import React from 'react'

import { PanelSeparator } from 'modules/workspace/components'
import { UpgradePersonalWorkspacePanel } from 'modules/workspace/components/UpgradePersonalWorkspacePanel'

interface PersonalWorkspaceSettingsGeneralProps {
  name: string
}

export const PersonalWorkspaceSettingsGeneral = ({
  name,
}: PersonalWorkspaceSettingsGeneralProps) => {
  return (
    <PanelSeparator>
      <UpgradePersonalWorkspacePanel name={name} />
    </PanelSeparator>
  )
}
